.base {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--bg-base, #0a0a0f);
  color: var(--text-primary, #e0e0e0);
  font-family: var(--font-sans, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif);
}

.logo {
  height: 32px;
  margin-bottom: 40px;
  opacity: 0.8;
}

.content {
  text-align: center;
  max-width: 400px;
}

.spinner {
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
  display: block;
  opacity: 0.6;
}

.check {
  margin: 0 auto 20px;
  display: block;
}

.error {
  margin: 0 auto 20px;
  display: block;
}

.title {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px;
  letter-spacing: -0.02em;
}

.subtitle {
  font-size: 14px;
  color: var(--text-muted, #888);
  margin: 0;
}

.redirect {
  font-size: 12px;
  color: var(--text-disabled, #555);
  margin-top: 16px;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
